module.exports = __webpack_public_path__ + "img/logo_main.26772f7d.png";